import React, { useState } from 'react';
import './GalleryPartners.css';

import { Heading, PageTitle } from '../../../components';
import { galleryPartners, titles } from '../../../constants';

import { FaPlus } from 'react-icons/fa';

import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";

import { useTranslation } from 'react-i18next';

const GalleryPartners = () => {

    // State to track the index of the currently displayed image in the lightbox
    const [index, setIndex] = useState(-1);
    const { t } = useTranslation();

    // Get the current image based on the selected index
    const currentImage = galleryPartners[index];

    // Calculate the index of the next image
    const nextIndex = (index + 1) % galleryPartners.length;
    const nextImage = galleryPartners[nextIndex] || currentImage;

    // Calculate the index of the previous image
    const prevIndex = (index + galleryPartners.length - 1) % galleryPartners.length;
    const prevImage = galleryPartners[prevIndex] || currentImage;

    // Function to open the lightbox with the selected image
    const openLightbox = (index) => setIndex(index);

    // Function to close the lightbox
    const closeLightbox = () => setIndex(-1);

    // Function to navigate to the previous image in the lightbox
    const handleMovePrev = () => setIndex(prevIndex);

    // Function to navigate to the next image in the lightbox
    const handleMoveNext = () => setIndex(nextIndex);

    return (
        <>
            {/* Page Title */}
            <PageTitle title={t(titles.galeria)} page={'Gallery'} />

            <section className='gallery'>

                {/* Section heading */}
                <Heading title={t(titles.galeria)} subTitle={t(titles.subTitleGaleria)} />

                <div className='box-container'>

                    {/* Render galleryPartners images */}
                    {galleryPartners.map((item, index) => {
                        return (
                            <div key={index} className={`gallery-item gallery-${index + 1}`}>
                                {/* Gallery image */}
                                <img src={item} alt='' />
                                <div className="content">
                                    {/* Button to open lightbox */}
                                    <button onClick={() => openLightbox(index)}>
                                        <FaPlus className='icon' />
                                    </button>
                                </div>
                            </div>
                        );
                    })}

                    {/* Render lightbox only when an image is selected */}
                    {index !== -1 && (
                        <Lightbox
                            mainSrc={currentImage} // Current image
                            mainSrcThumbnail={currentImage} // Thumbnail of the current image
                            nextSrc={nextImage} // Next image
                            nextSrcThumbnail={nextImage} // Thumbnail of the next image
                            prevSrc={prevImage} // Previous image
                            prevSrcThumbnail={prevImage} // Thumbnail of the previous image
                            onCloseRequest={closeLightbox} // Close lightbox function
                            onMovePrevRequest={handleMovePrev} // Navigate to previous image
                            onMoveNextRequest={handleMoveNext} // Navigate to next image
                        />
                    )}

                </div>

            </section>

        </>
    );
};

export default GalleryPartners;